import React, { Component } from "react";
import styled from "styled-components";
import Header from "../Component/Header";
import Contents from "../Component/Contents";
import Buttons from "../Component/Buttons";
import Cont from "../Component/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faQuestion,
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import OfferPic from "../Img/Offer.png";
import Height from "../Height";

class Offer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="fadeIn">
        <Cont className="container">
          <Header
            title={OfferPic}
            desc="주장을 재정리하고 최종 제안을 하세요!"
            stage="1"
          ></Header>
          <Contents stage="offer" placeholder="그러니 ..하라."></Contents>
          <Buttons
            array={[
              [<FontAwesomeIcon icon={faArrowLeft} />, "/example"],
              ["info", "그러니 위 건강을 위해 양배추를 꾸준히 챙겨 먹자."],
              [<FontAwesomeIcon icon={faCheck} />, "/finish"]
            ]}
          ></Buttons>
        </Cont>
        {/* <Footer stage="5"></Footer> */}
      </div>
    );
  }
}

export default Offer;
